import React, { useState } from 'react';
import { cardTypes } from '../../agentTheme';

const IMG_RE = /https?:\/\/[^\s)]+\.(?:jpg|jpeg|png|gif|webp|avif|svg)(?:\?[^\s)]*)?/gi;

/**
 * Renders asset approval messages as a compact card instead of raw text.
 * Detects messages starting with "Approved assets for image generation".
 */
export default function AssetApprovalCard({ text }) {
  const [expanded, setExpanded] = useState(false);

  // Extract image URLs from the raw text
  const urls = [...(text.match(IMG_RE) || [])];
  const displayUrls = expanded ? urls : urls.slice(0, 4);
  const overflow = urls.length - 4;

  return (
    <div
      className="smart-card"
      style={{
        background: cardTypes.approval.bg,
        border: `1px solid ${cardTypes.approval.border}`,
        cursor: urls.length > 4 ? 'pointer' : 'default',
      }}
      onClick={() => urls.length > 4 && setExpanded(e => !e)}
    >
      <div className="smart-card-header" style={{ color: cardTypes.approval.accent }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
        Assets approved
      </div>

      {urls.length > 0 && (
        <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
          {displayUrls.map((url, i) => (
            <img
              key={i}
              src={url}
              alt=""
              style={{
                width: 40, height: 40, borderRadius: 8, objectFit: 'cover',
                border: `1px solid ${cardTypes.approval.border}`,
              }}
              onError={e => { e.target.style.display = 'none'; }}
            />
          ))}
          {!expanded && overflow > 0 && (
            <div style={{
              width: 40, height: 40, borderRadius: 8,
              background: 'rgba(74,222,128,0.08)', border: `1px solid ${cardTypes.approval.border}`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 11, color: 'rgba(255,255,255,0.3)', fontWeight: 600,
            }}>
              +{overflow}
            </div>
          )}
        </div>
      )}

      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.2)', marginTop: 6 }}>
        Ready for generation
      </div>
    </div>
  );
}
